import { Avatar, Stack, Tooltip, Typography } from "@mui/material";
import * as strings from "common/strings";
import CopyButton from "components/common/CopyButton";

const UserDetail = ({ email, id, compact }) => {
  const emailMeta = strings.extractNameFromEmail(email);
  const color = strings.stringToColor(email);

  const avatarSx = {
    width: compact ? "1.625rem" : "2rem",
    height: compact ? "1.625rem" : "2rem",
    fontSize: compact ? "0.75rem" : "0.875rem",
    fontWeight: 600,
    bgcolor: color,
  };

  return (
    <Tooltip title={compact ? email : null}>
      <Stack
        display={"inline-flex"}
        direction={"row"}
        alignItems={"baseline"}
        justifyContent={"center"}
        gap={1}
      >
        <Stack>
          <Avatar sx={avatarSx}>{emailMeta.initials}</Avatar>
          {id && (
            <CopyButton content={id} tooltip={"Copy user ID"} scale={"small"} />
          )}
        </Stack>

        <Stack>
          {emailMeta.name}
          {!compact && (
            <Stack>
              <Typography
                variant={"caption"}
                color={color}
                sx={{ marginTop: "-3px" }}
              >
                {email}
              </Typography>
              {id && (
                <Typography variant={"caption"} color={"grey"}>
                  {id}
                </Typography>
              )}
            </Stack>
          )}
        </Stack>
      </Stack>
    </Tooltip>
  );
};

export default UserDetail;
